import { render } from "./AddDocuments.vue?vue&type=template&id=6697a339&scoped=true&ts=true"
import script from "./AddDocuments.vue?vue&type=script&lang=ts"
export * from "./AddDocuments.vue?vue&type=script&lang=ts"

import "./AddDocuments.vue?vue&type=style&index=0&id=6697a339&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6697a339"]])

export default __exports__